import React from 'react';
import { Turnstile } from 'react-turnstile';

/**
 * Cloudflare Turnstile widget for bot protection.
 * Renders nothing if REACT_APP_TURNSTILE_SITE_KEY is not set (dev/local).
 * @param {Function} onVerify - Called with token when verified
 * @param {string} action - Action name for analytics (e.g. 'login', 'register')
 * @param {string} theme - 'light', 'dark', or 'auto'
 */
const TurnstileWidget = ({ onVerify, action = 'login', theme = 'light' }) => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  if (!siteKey) {
    return null;
  }

  return (
    <div className="flex justify-center my-4">
      <Turnstile
        sitekey={siteKey}
        onVerify={onVerify}
        action={action}
        theme={theme}
        size="normal"
        refreshExpired="auto"
      />
    </div>
  );
};

export default TurnstileWidget;

/** Returns true if Turnstile is configured (requires verification) */
export const isTurnstileEnabled = () => !!process.env.REACT_APP_TURNSTILE_SITE_KEY;
